<template>
  <Imgsee ref="Imgsee" :url="info.url" :name='info.title || info.origin_name' v-if="visible && info.type == 3"
    @close="visible = false"></Imgsee>
  <div class="filebox" v-else>
    <drag-modal :visible="visible" @cancel="cancel" :title='info.title' width='740px' :zIndex='10001'>

      <div class="downButton">
        <a @click="editFile" v-if="(info.type == 4 && info.message_type == 'document') || info.folderShow === true"
          target="_blank" :download="info.title || info.origin_name" class="Edit">
          编辑
        </a>
        <a :href="downFile(info)" v-if="info.message_type != 'document'" target="_blank"
          :download="info.title || info.origin_name" class="down">下载</a>
      </div>
      <video :src="info.url" v-if='info.type == 0' controls="controls" width='100%' height='600'></video>
      <video :src="info.url" v-if='info.type == 5 || info.type == 1' controls="controls" width='100%'
        height='30'></video>
      <iframe :src="info.url" v-if='info.type == 2' frameborder="0" width='100%' height='600'
        @load="handleIframeLoad"></iframe>
      <div v-if="info.type == 4" ref="container" style="width: 100%;height: 600px;"></div>
      <div class="amrPLay" v-if='info.type == 6'>
        <div class="yingping">
          <a-button @click="playstop()" v-show="!shpzt">暂停</a-button>
          <a-button @click="play(info.url)" v-show="shpzt">播放</a-button>
          <input class="amr-progress" type="range" min="0" max="1" step="any" :value="ypdt" disabled>
          <span id="amr-cur">{{ ypdt }}'</span>
          <span>/</span>
          <span id="amr-duration">{{ ypleng }}'</span>
        </div>
      </div>
    </drag-modal>
  </div>
</template>
<script>
import { Tacitly } from '@/assets/js/Tacitly'
import { getFilePath } from '../../assets/js/fileIcon'
import Imgsee from "./img.vue"
import { onlineUrlToken } from '@/server/api'
import BenzAMRRecorder from 'benz-amr-recorder'


let amr;
export default {
  props: {
    info: {
      type: Object,   //0 视频 1音乐 2pdf  3图片
      default() {
        return {

        }
      }
    },
  },
  data() {
    return {
      visible: false,
      ypleng: 0,
      ypdt: 0,
      shpzt: true,
      editFileURL: '',
      editFileVisible: false,
      instance: null
    }
  },
  components: {
    Imgsee,
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.destroyWebOffice();
      }
    },

    info: {
      immediate: true,
      deep: true,
      handler(data) {
        if (data && data.url) {
          this.$nextTick(() => {
            this.initWebOffice(data.url, data.access_token);
          });
        }
      }
    }
  },
  methods: {
    initWebOffice(url, token) {//挂载实例
      if (this.instance) {
        return;
      }
      const container = this.$refs.container;
      if (!container) {
        return;
      }
      this.instance = aliyun.config({
        mount: container,
        url: url
      });
      if (typeof this.instance.setToken === "function") {
        this.instance.setToken({
          token
        });
      }
    },
    handleIframeLoad() {
    },
    getFilePath,
    editFile() {
      const { Original_url, url, title } = this.info;
      this.visible = false;
      onlineUrlToken({
        object: Original_url || url,
        type: 'edit'
      }).then(res => {
        res.file_name = title
        this.$store.dispatch('setEditFileURL', res);
        this.$store.dispatch('openkey', {
          key: 'fileEditing',
          by: true
        });
      });
    },
    downFile(i) {
      const baseUrl = Tacitly.Base_Port;
      return `${baseUrl}common/download?url=${encodeURIComponent(i.url)}&filename=${encodeURIComponent(i.title || i.origin_name)}`
    },
    downloadFiles(i) {
      const url = this.downFile(i)
      fetch(url)
        .then(res => res.blob())
        .then(blob => {
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = i.title
          link.click()
          URL.revokeObjectURL(link.href)
        })
    },
    play(url) {
      let that = this;
      this.shpzt = !this.shpzt
      amr = new BenzAMRRecorder();
      amr.initWithUrl(url).then(function () {
        amr.play();
        that.ypleng = amr.getDuration().toFixed(2)
        var iCount = setInterval(function () {
          let spchang = amr.getCurrentPosition().toFixed(2)
          if (spchang != 0.00) {
            that.ypdt = amr.getCurrentPosition().toFixed(2)
          } else {
            clearInterval(iCount);

          }
        }, 30);

      });
      amr.onEnded(function () {
        that.shpzt = true
        that.ypdt = 0
      })
    },
    //停止播放
    playstop() {
      this.shpzt = !this.shpzt
      amr.stop();
    },
    destroyWebOffice() {
      if (this.instance && typeof this.instance.destroy === "function") {//销毁实例
        this.instance.destroy();
      }
      this.instance = null;
    },
    cancel() {
      this.visible = false
    }
  }
}
</script>
<style lang="less" scoped>
.Edit {
  width: 80px;
  line-height: 30px;
  background: #ffb618;
  color: #fff;
  text-align: center;
  font-size: 0.875rem;
  border-radius: 4px;
}

.downButton {
  position: absolute;
  top: 15px;
  right: 40px;
  width: 180px;
  display: flex;
  justify-content: end;
  gap: 15px;
}

.down {
  width: 80px;
  line-height: 30px;
  background: #1890ff;
  color: #fff;
  text-align: center;
  font-size: 0.875rem;
  border-radius: 4px;
}
</style>